import React from "react";
import { connect } from "react-redux";
import * as userActions from "../redux/actions/userActions";
import * as questionActions from "../redux/actions/questionActions";
import { Dropdown } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { restState } from "../redux/localStorage";
function LoginButton(props:any) {
  const history = useHistory();
  const loginUser = (user = {}) => {
    if (Object.keys(user).length === 0) {
      props.userLogout();
      restState();
      history.push("/login");
      window.location.href = "/";
    } else {
      props.userLogin(user);
      props.getAllQuestions();
      history.push("/");
    }
  };
  return (
    <>
      <Dropdown>
        <Dropdown.Toggle className="btn btn-success btn-sm" id="dropdown-basic">
          {props.loggedUser.name ? props.loggedUser.name : "Login"}
        </Dropdown.Toggle>
        <Dropdown.Menu align="right">
          <div className={props.loggedUser.id ? "isHidden" : "isVisible"}>
            {props.users.map((user:any) => (
              <Dropdown.Item onClick={() => loginUser(user)} key={user.id}>
                {user.name}
              </Dropdown.Item>
            ))}
          </div>
          <div className={props.loggedUser.id ? "isVisible" : "isHidden"}>
            <Dropdown.Item onClick={() => loginUser()}>Logout</Dropdown.Item>
          </div>
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
}
const mapStateToProps = (state:any) => {
  return {
    users: state.userReducer.users,
    loggedUser: state.userReducer.loggedUser,
  };
};

const mapDispatchToProps = (dispatch:any) => {
  return {
    userLogin: (user: any) => dispatch(userActions.userLogin(user)),
    userLogout: () => dispatch(userActions.userLogout()),
    getAllQuestions: () => dispatch(questionActions.getAllQuestions()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(LoginButton);
